export function getPrCommentDate(comment, platform) {
    return getReadableDate(comment.commentDate);
}

export function getReadableDate(date) {
    let newDate = new Date(date);
    return newDate.toDateString();
}

export function getTimeDifference(startDate, endDate) {
    const seconds = Math.floor((endDate - startDate) / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    let hoursString = "";
    if (hours && hours > 0) {
        hoursString = hours + " Hrs";
    }
    let minutesString = "";
    if (minutes && minutes > 0) {
        minutesString = minutes + " Mins";
    }

    let secondsString = "";
    if (seconds && seconds > 0) {
        secondsString = seconds + " Secs";
    }

    return hoursString + " " + minutesString + " " + secondsString;
}

export function formatDateForCommit (parameters) {
    return getReadableDate(parameters.value);
}